<template>
  <div class="page-content">
    <div class="privacy-container">
      <h1 class="privacy-title">Tietosuojaseloste</h1>
      
      <div class="privacy-content">
        <div class="privacy-section">
          <h2>1. Rekisterinpitäjä</h2>
          <p>
            <strong>Yritys:</strong> RemmiGames Oy<br>
            <strong>Y-tunnus:</strong> 3541024-5<br>
            <strong>Yhteystieto tietosuoja-asioissa:</strong> <a href="mailto:info@raviremmi.com" class="contact-link">info@raviremmi.com</a>
          </p>
        </div>

        <div class="privacy-section">
          <h2>2. Henkilötietojen Käsittelyn Tarkoitus</h2>
          <p>
            Käsittelemme henkilötietojasi seuraaviin tarkoituksiin:
          </p>
          <ul>
            <li>Käyttäjätilin luominen ja ylläpito</li>
            <li>Palvelun toiminnan mahdollistaminen</li>
            <li>Käyttäjän tunnistaminen ja autentikointi</li>
            <li>Yhteydenotto tarvittaessa</li>
            <li>Palvelun kehittäminen ja parantaminen</li>
          </ul>
        </div>

        <div class="privacy-section">
          <h2>3. Käsiteltävät Henkilötiedot</h2>
          <p>Keräämme ja käsittelemme seuraavia henkilötietoja:</p>
          <ul>
            <li><strong>Sähköpostiosoite:</strong> Käyttäjätilin luomiseen ja yhteydenpitoon</li>
            <li><strong>Käyttäjänimi/Remmin nimi:</strong> Pelissä näkyvä julkinen nimi</li>
            <li><strong>Etunimi:</strong> Käyttäjän tunnistamiseen (ei julkinen)</li>
            <li><strong>Sukunimi:</strong> Käyttäjän tunnistamiseen (ei julkinen)</li>
            <li><strong>Google-tilin yksilöllinen tunniste:</strong> Google-kirjautumisen yhdistämiseen oikeaan Raviremmi-tiliin</li>
            <li><strong>Rekisteröitymisaika:</strong> Tilin luomisen ajankohta</li>
            <li><strong>Pelitiedot:</strong> Pelisuoritukset, valinnat ja pisteet</li>
          </ul>
        </div>

        <div class="privacy-section">
          <h2>4. Google-kirjautuminen</h2>
          <p>
            Google-kirjautuminen on vapaaehtoinen vaihtoehto salasanalla kirjautumiselle. Kun valitset
            Google-kirjautumisen, Google toimii tunnistautumisen tarjoajana ja välittää tiedot Raviremmille
            Amazon Web Services (AWS) Cognito -palvelun kautta.
          </p>
          <p>
            Raviremmi pyytää vain OpenID Connect -oikeudet <code>openid</code>, <code>email</code> ja
            <code>profile</code>. Näiden perusteella Raviremmi käsittelee Google-tilin yksilöllistä tunnistetta,
            varmennetun sähköpostiosoitteen sekä etu- ja sukunimen. <code>profile</code>-oikeudesta Raviremmi
            tallentaa vain etu- ja sukunimen; Google-profiilikuvaa ei tallenneta.
          </p>
          <p>
            Tietoja käytetään ainoastaan uuden Raviremmi-tilin luomiseen, kirjautumiseen, samalla varmennetulla
            sähköpostiosoitteella olemassa olevaan Raviremmi-tiliin yhdistämiseen sekä tilien sekoittumisen
            estämiseen. Google-salasanaasi ei välitetä Raviremmille.
          </p>
          <p>
            Raviremmi ei pyydä pääsyä Gmailin, Driven, Kalenterin tai muiden Google-palvelujen sisältöihin.
            Googlelta saatuja tietoja ei käytetä mainontaan eikä niitä näytetä muille pelaajille. Raviremmin
            puolella tiedot tallennetaan AWS Cognitoon ja Raviremmin AWS-tietokantaan EU-alueella tämän
            selosteen mukaisesti.
          </p>
          <p>
            Voit perua Raviremmin Google-yhteyden Google-tilisi kolmannen osapuolen yhteyksien asetuksista.
            Yhteyden peruminen ei automaattisesti poista Raviremmi-tiliä tai siihen liittyviä pelitietoja.
            Voit pyytää Raviremmi-tilisi ja henkilötietojesi poistamista osoitteesta info@raviremmi.com.
          </p>
          <p>
            Googlelta saatujen tietojen käyttö noudattaa
            <a
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noopener noreferrer"
              class="contact-link"
            >Google API Services User Data Policy</a> -ehtoja, mukaan lukien Limited Use -vaatimukset.
          </p>
        </div>

        <div class="privacy-section">
          <h2>5. Tietojen Julkisuus</h2>
          <p>
            <strong>Julkiset tiedot:</strong> Ainoastaan käyttäjänimi/remmin nimi on näkyvissä muille pelaajille 
            tulostaulukoissa ja pelitilanteissa.
          </p>
          <p>
            <strong>Yksityiset tiedot:</strong> Sähköpostiosoite, etunimi ja sukunimi ovat näkyvissä vain 
            palvelun ylläpidolle eivätkä ole muiden käyttäjien nähtävissä.
          </p>
        </div>

        <div class="privacy-section">
          <h2>6. Käsittelyn Oikeusperuste</h2>
          <p>
            Henkilötietojen käsittely perustuu:
          </p>
          <ul>
            <li><strong>Sopimukseen:</strong> Palvelun tarjoaminen edellyttää käyttäjätilin luomista</li>
            <li><strong>Oikeutettuun etuun:</strong> Palvelun kehittäminen ja ylläpito</li>
            <li><strong>Suostumukseen:</strong> Vapaaehtoisten lisätietojen antaminen</li>
          </ul>
        </div>

        <div class="privacy-section">
          <h2>7. Tietojen Säilytysaika</h2>
          <p>
            Säilytämme henkilötietojasi niin kauan kuin:
          </p>
          <ul>
            <li>Käyttäjätilisi on aktiivinen</li>
            <li>Se on tarpeen palvelun tarjoamiseksi</li>
            <li>Laki edellyttää tietojen säilyttämistä</li>
          </ul>
          <p>
            Voit pyytää tietojesi poistamista ottamalla yhteyttä osoitteeseen info@raviremmi.com.
          </p>
        </div>

        <div class="privacy-section">
          <h2>8. Tietojen Siirto ja Käsittely</h2>
          <p>
            <strong>Autentikointi:</strong> Käyttäjien tunnistaminen ja salasanojen hallinta tapahtuu 
            Amazon Web Services (AWS) Cognito -palvelun kautta. AWS Cognito tallentaa salasanat 
            turvallisesti hajautettuna (hash), eikä palvelun ylläpito pääse käsiksi alkuperäisiin salasanoihin.
          </p>
          <p>
            <strong>Tietojen sijainti:</strong> Tiedot säilytetään AWS:n palvelimilla EU-alueella 
            (Tukholma, Ruotsi) tietosuoja-asetuksen mukaisesti.
          </p>
          <p>
            <strong>Mahdolliset EU-ulkoiset siirrot:</strong> Vaikka tiedot säilytetään EU-alueella, 
            AWS:n tukipalvelut tai tekninen ylläpito saattavat edellyttää pääsyä tietoihin EU:n ulkopuolelta. 
            Tällaisissa tapauksissa AWS soveltaa EU-komission hyväksymiä Standard Contractual Clauses 
            -lausekkeita (SCC) asianmukaisten suojatoimien varmistamiseksi.
          </p>
          <p>
            <strong>Tietoturva:</strong> Käytämme alan standardien mukaisia teknisiä ja organisatorisia 
            toimenpiteitä tietojesi suojaamiseksi.
          </p>
        </div>

        <div class="privacy-section">
          <h2>9. Rekisteröidyn Oikeudet</h2>
          <p>Sinulla on oikeus:</p>
          <ul>
            <li><strong>Tarkastusoikeus:</strong> Saada tieto käsiteltävistä henkilötiedoistasi</li>
            <li><strong>Oikaisuoikeus:</strong> Pyytää virheellisten tietojen korjaamista</li>
            <li><strong>Poisto-oikeus:</strong> Pyytää tietojesi poistamista</li>
            <li><strong>Käsittelyn rajoittaminen:</strong> Pyytää käsittelyn rajoittamista tietyissä tilanteissa</li>
            <li><strong>Siirrettävyys:</strong> Saada tietosi koneluettavassa muodossa</li>
            <li><strong>Vastustamisoikeus:</strong> Vastustaa tietojesi käsittelyä tietyissä tilanteissa</li>
          </ul>
          <p>
            Voit käyttää oikeuksiasi ottamalla yhteyttä osoitteeseen: 
            <a href="mailto:info@raviremmi.com" class="contact-link">info@raviremmi.com</a>
          </p>
        </div>

        <div class="privacy-section">
          <h2>10. Evästeet (Cookies)</h2>
          <p>
            Palvelu käyttää välttämättömiä evästeitä kirjautumisen ylläpitämiseksi ja palvelun 
            toiminnan varmistamiseksi. Nämä evästeet ovat teknisesti välttämättömiä palvelun käytölle.
          </p>
        </div>

        <div class="privacy-section">
          <h2>11. Muutokset Tietosuojaselosteeseen</h2>
          <p>
            Pidätämme oikeuden päivittää tätä tietosuojaselostetta. Merkittävistä muutoksista 
            ilmoitamme palvelussa tai sähköpostitse.
          </p>
        </div>

        <div class="privacy-section">
          <h2>12. Valvontaviranomainen</h2>
          <p>
            Jos koet, että henkilötietojesi käsittely ei ole tietosuoja-asetuksen mukaista, 
            voit tehdä valituksen Tietosuojavaltuutetulle:
          </p>
          <p>
            <strong>Tietosuojavaltuutetun toimisto</strong><br>
            PL 800, 00521 Helsinki<br>
            Puhelin: 029 566 6700<br>
            Sähköposti: tietosuoja@om.fi<br>
            Verkkosivu: <a href="https://tietosuoja.fi" target="_blank" rel="noopener noreferrer" class="contact-link">tietosuoja.fi</a>
          </p>
        </div>

        <div class="privacy-section">
          <h2>13. Ikärajoitukset ja Alaikäisten Käyttäjien Tiedot</h2>
          <p>
            Palvelumme on suunnattu vähintään 13-vuotiaille käyttäjille. Suomessa digitaalisen suostumuksen ikäraja on 13 vuotta.
          </p>
          <p>
            <strong>Alle 13-vuotiaat käyttäjät:</strong> Jos käyttäjä on alle 13-vuotias, hänen huoltajansa suostumus vaaditaan 
            henkilötietojen käsittelyyn. Huoltajan tulee antaa suostumus lapsen puolesta ja valvoa palvelun käyttöä.
          </p>
          <p>
            <strong>Huoltajien oikeudet:</strong> Huoltajilla on oikeus tarkastaa, muuttaa tai pyytää lapsensa tietojen poistamista 
            ottamalla yhteyttä osoitteeseen info@raviremmi.com.
          </p>
        </div>

        <div class="privacy-footer">
          <p><strong>Viimeksi päivitetty:</strong> {{ lastUpdated }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      lastUpdated: '27.9.2026'
    }
  }
}
</script>

<style scoped>
.page-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.privacy-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.privacy-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #64ffda;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.privacy-content {
  background: #112240;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
  border: 1px solid #1e3a5f;
  color: #a8b2d1;
  line-height: 1.6;
}

.privacy-section {
  margin-bottom: 2rem;
}

.privacy-section:last-child {
  margin-bottom: 0;
}

.privacy-section h2 {
  color: #e6f1ff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #1e3a5f;
}

.privacy-section p {
  margin-bottom: 1rem;
  font-size: 1rem;
}

.privacy-section p:last-child {
  margin-bottom: 0;
}

.privacy-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.privacy-section li {
  margin-bottom: 0.5rem;
}

.contact-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.privacy-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #1e3a5f;
  text-align: center;
  font-size: 0.9rem;
  color: #8892b0;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .privacy-title {
    font-size: 1.8rem;
  }
  
  .privacy-content {
    padding: 1.5rem;
  }
  
  .privacy-section h2 {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .privacy-content {
    padding: 1rem;
  }
  
  .privacy-section ul {
    padding-left: 1.5rem;
  }
}
</style>
